"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.LINK_API_URL=void 0,exports.LINK_API_URL="https://www.walletlink.org";